var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"button-back"},'button',_vm.$attrs,false),_vm.$listeners),[_c('v-icon-arrow-left'),_vm._v(" Назад ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }